export default "__VITE_ASSET__CVx9irIz__"